import { useQuery } from '@tanstack/react-query';
import { fetchAllUsersList } from '../data-provider/traffic-coordinator-List';
import type { userListParams } from '../data-provider/traffic-coordinator-List/api';

export const useGetTrafficCoordinators = (params: userListParams) => {
  return useQuery({
    queryKey: ['savers-all-users-list', params.companyId, params.userType],
    queryFn: () => fetchAllUsersList(params),
    staleTime: Number.POSITIVE_INFINITY,
    enabled: Boolean(params.companyId),
  });
};
